<template>
    <div class="pa-5 pt-0">
        <v-divider class="mb-3" />
        <div>
            <strong>{{ "Other" | t }}:</strong>
        </div>
        <v-row>
            <v-col class="row-title col-item" cols="3">{{ "Has product label" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeProduct.has_product_label ? t("Yes") : t("No") }}
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "package-other-tab",
    computed: {
        ...mapState("ProductStore", ["activeProduct"])
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}
.col-item {
    padding-top: 2px;
    padding-bottom: 2px;
}
</style>
